// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// window.__zone_symbol__UNPATCHED_EVENTS = ['scroll']
window.__zone_symbol__UNPATCHED_EVENTS = []
